const swiperHow = new Swiper('.swiper-how', {
    slidesPerView: 1,
    loop: false,
    rewind: true,
    spaceBetween: 15,
    autoHeight: true,
    navigation: {
        nextEl: '.arrows-container .swiper-button-next',
        prevEl: '.arrows-container .swiper-button-prev',
    },
    breakpoints: {
        992: {
            slidesPerView: "auto",
            centeredSlides: false,
            autoHeight: false
        },
    },
    on: {
        init: adjustSwiperHeight,
        resize: adjustSwiperHeight,
    },
});

function adjustSwiperHeight() {
    const slides = document.querySelectorAll('.swiper-how .swiper-slide');
    let maxHeight = 0;

    if (window.innerWidth > 992) {
        // reset height
        slides.forEach(slide => {
            slide.style.height = 'auto';
            const h = slide.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
    
        // apply the tallest height to all
        slides.forEach(slide => {
            slide.style.height = `${maxHeight}px`;
        });
    } else {
        return;
    }
}